import { Box, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { DriveContentType } from 'src/@types/drive';
import { CircularProgressWithLabel } from 'src/components/CircularProgressWithLabel';
import FileThumbnail from 'src/components/file-thumbnail';
import TextMaxLine from 'src/components/text-max-line';
import { useDownloadDriveContent } from 'src/sections/@dashboard/drive/DownloadDriveContent';
import { DriveMediaContentView } from 'src/sections/@dashboard/drive/DriveMediaContenView';
import { FormatTime } from 'src/utils/formatTime';
import { CloudContentActions } from './CloudContentActions';
import { CustomCloudListItem } from './styles';
import type { ContentCardProps } from './types';

export default function FileListCloudCard({
  content,
  handleOpenFolder,
}: ContentCardProps) {
  const [openMediaContent, setOpenMediaContent] = useState(false);
  const isFile = content.type === DriveContentType.FILE;
  const { downloadContent, loadingProgress } = useDownloadDriveContent(content);

  const handleOpenMedia = () => {
    if (content.type === DriveContentType.FILE) {
      setOpenMediaContent(true);
    }
  };
  const handleCloseMedia = () => {
    setOpenMediaContent(false);
  };

  const handleCardClick = () => {
    if (content.type === DriveContentType.FOLDER) {
      handleOpenFolder(content._id);
      return;
    }
    handleOpenMedia();
  };
  return (
    <>
      <CustomCloudListItem>
        <Stack
          width="100%"
          direction="row"
          alignItems="center"
          gap={2}
          onClick={handleCardClick}
        >
          {isFile ? (
            <FileThumbnail file={content.name} sx={{ width: 30, height: 30 }} />
          ) : (
            <Box
              component="img"
              src="/assets/icons/files/ic_folder.svg"
              sx={{ width: 30, height: 30 }}
            />
          )}
          <Stack justifyContent="center" height="40px">
            <TextMaxLine variant="body2" persistent>
              {content.name}
            </TextMaxLine>
            <Typography color="text.secondary" variant="caption">
              {FormatTime.DateTime(content.updatedAt)}
            </Typography>
          </Stack>
        </Stack>
        {loadingProgress.loading && (
          <CircularProgressWithLabel
            size={24}
            value={loadingProgress.progress}
          />
        )}
        <CloudContentActions
          driveContent={content}
          downloadContent={downloadContent}
        />
      </CustomCloudListItem>
      {openMediaContent && (
        <DriveMediaContentView file={content} onClose={handleCloseMedia} />
      )}
    </>
  );
}
